<template>
	<div>

		<egranty-input-field-popup
			:is-open.sync="renamePopupVisible"
			label="Nowa nazwa"
			for="area-tab-new-name"
			id="area-tab-new-name"
			title="Zmień nazwę obszaru"
			long
			@save="rename"
		></egranty-input-field-popup>

		<v-toolbar class="area-tab-toolbar blue">
			<v-toolbar-title class="area-tab-toolbar-title"> Obszar ({{ active[0].name }})</v-toolbar-title>
		</v-toolbar>
		<v-container style="padding: 12px;">
			<div>
				<v-btn @click="copyArea(active[0])"> Kopiuj obszar</v-btn>
			</div>
			<div>
		<v-btn
			color="lightred"
			:disabled="disabled"
			@click="deleteArea(active[0].id)"> Usuń
		</v-btn>
		<v-btn @click="putHigher">
			<v-icon color="white">arrow_upward</v-icon>
		</v-btn>
		<v-btn @click="putLower">
			<v-icon color="white">arrow_downward</v-icon>
		</v-btn>
		<v-btn @click="renamePopupVisible= true"> zmień nazwę</v-btn>
	</div>
		</v-container>
	</div>
</template>
<script>
	import {AgencyTask} from "../../../../api/generated/AgencyTask";
	import EgrantyInputFieldPopup from "../../../../genericComponents/EgrantyInputFieldPopup";


	export default {
		name: "AreaTab",
		components: {EgrantyInputFieldPopup},
		methods: {

			getContestId() {
				return this.$route.params.id;
			},

			deleteArea(id) {
				AgencyTask.deleteArea(
					this,
					id, () => {
						this.$emit("refresh");
					}, errorResponse => {
						if (errorResponse.status === "NOT_ACCEPTABLE") {
							this.$emit("removalError", errorResponse);
						}
					});
			},

			putHigher() {
				AgencyTask.postAreaHigherInView(
					this,
					this.active[0].id,
					() => this.$emit("refresh"),
				);
			},

			putLower() {
				AgencyTask.postAreaLowerInView(
					this,
					this.active[0].id,
					() => this.$emit("refresh"),
				);
			},


			rename(newName) {
				AgencyTask.postRenameArea(
					this,
					this.active[0].id,
					newName,
					() => {
						this.$emit("refresh");
					});
			},
			copyArea(area){
				let copiedObject = {
					type: area.type,
					id: area.id,
					onlyChildNodes: false
				};
				this.$emit("copyObject",copiedObject);
			}

		},


		data() {
			return {
				extraData: {},
				renamePopupVisible: false,
			};
		},

		props: {
			active: {},
			disabled: {type: Boolean, default: false},
			copiedObject: {
				type: Object,
				default: function () {
					return {};
				},
			}
		},
	};
</script>

